import { createNewHandbookApi } from '@/api/handbookApi'
import { createHandbookResponseErrors } from '@/utils/error/responseErrors'
import { POSITION_PROPERTY_URL } from '@/api/handbook/position'

export const COATING_COLOR_URL = `${POSITION_PROPERTY_URL}/colors`

const errors = createHandbookResponseErrors('цвет', 'цветов')

export const CoatingColorApi = createNewHandbookApi(COATING_COLOR_URL, errors)
